const BasicKeywords = () => {
    return(
        <div className="demo-container">
            <div className="demo-box">
                <div className="lead">Separation of Concerns</div>
                <code>In computer science, separation of concerns is a design principle for separating a computer program into distinct sections. Each section addresses a separate concern, a set of information that affects the code of a computer program. Separation of concerns results in more degrees of freedom for some aspect of the program's design, deployment, or usage.</code>
                <div className="lead">Immutable</div>
                <code>In object-oriented and functional programming, an immutable object (unchangeable object) is an object whose state cannot be modified after it is created.</code>
            </div>
            <div className="demo-box">
                <div className="lead">Imperative vs Declarative</div>
                <code>https://stackoverflow.com/questions/1784664/what-is-the-difference-between-declarative-and-imperative-paradigm-in-programmin</code>
            </div>
        </div>
    )
}

export default BasicKeywords